import { Table } from "antd";
import COLORS from "common/Colors";
import React from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { RightOutlined } from "@ant-design/icons";

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: normal;
  }

  .wrap-column {
    white-space: normal !important;
    word-break: break-word;
    min-width: 200px;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const ViewKpi = ({ dataList, headerContent }) => {
  console.log("dataList-->", dataList);
  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: <div style={{ whiteSpace: "wrap" }}>KPI Category</div>,
      dataIndex: "kpicategory",
      key: "kpicategory",
      width: "30%",
      //   render: (text, record, index) => (
      //     <>
      //       {status === "view" ? (
      //         record?.kpicategory
      //       ) : (
      //         <Input.TextArea
      //           autoSize={{ minRows: 1, maxRows: 6 }}
      //           value={record?.kpicategory}
      //           style={{
      //             width: "100%",
      //             border:
      //               invalidFields.strategic.includes(index) && !record.kpicategory
      //                 ? "1px solid red"
      //                 : "",
      //           }}
      //           status={
      //             invalidFields.strategic.includes(index) && !record.kpicategory
      //               ? "error"
      //               : ""
      //           }
      //           onChange={(e) =>
      //             handleTableDataChange(index, "kpicategory", e.target.value)
      //           }
      //         />
      //       )}
      //     </>
      //   ),
    },
    {
      title: "KPI Name & Description",
      dataIndex: "kpidescription",
      key: "kpidescription",
      width: "30%",
      className: "wrap-column",
      render: (text, record, index) => (
        <>
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {record?.kpidescription}
          </div>
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedoutcomes",
      key: "expectedoutcomes",
      width: "30%",
      //   render: (text, record, index) => (
      //     <>
      //       {status === "view" ? (
      //         record?.expectedoutcomes
      //       ) : (
      //         <Input.TextArea
      //           autoSize={{ minRows: 1, maxRows: 6 }}
      //           value={record?.expectedoutcomes}
      //           style={{
      //             width: "100%",
      //             border:
      //               invalidFields.strategic.includes(index) &&
      //               !record.expectedoutcomes
      //                 ? "1px solid red"
      //                 : "",
      //           }}
      //           status={
      //             invalidFields.strategic.includes(index) &&
      //             !record.expectedoutcomes
      //               ? "error"
      //               : ""
      //           }
      //           onChange={(e) =>
      //             handleTableDataChange(index, "expectedoutcomes", e.target.value)
      //           }
      //         />
      //       )}
      //     </>
      //   ),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      key: "weightage",
      width: "10%",
      //   render: (text, record, index) => (
      //     <>
      //       {status === "view" ? (
      //         record?.weightage
      //       ) : (
      //         <Input
      //           value={record?.weightage}
      //           style={{
      //             border:
      //               invalidFields.strategic.includes(index) && !record.weightage
      //                 ? "1px solid red"
      //                 : "",
      //           }}
      //           status={
      //             invalidFields.strategic.includes(index) && !record.weightage
      //               ? "error"
      //               : ""
      //           }
      //           onKeyDown={(event) => {
      //             if (
      //               !/[0-9]/.test(event.key) &&
      //               event.key !== "Backspace" &&
      //               event.key !== "Tab"
      //             ) {
      //               event.preventDefault();
      //             }
      //           }}
      //           onChange={(e) =>
      //             handleTableDataChange(index, "weightage", e.target.value)
      //           }
      //         />
      //       )}
      //     </>
      //   ),
    },
    // {
    //   title: "",
    //   key: "action",
    //   render: (text, record, index) => {
    //     const isLastRow = tableData[tableData.length - 1]?.id === record.id;
    //     return (
    //       isLastRow &&
    //       index !== 0 && (
    //         <DeleteOutlineOutlined
    //           disabled={tableData?.length === 1}
    //           onClick={() => handleDeleteRow(record.id)}
    //           style={{ color: "#2D53DA", cursor: "pointer" }}
    //         >
    //           Delete
    //         </DeleteOutlineOutlined>
    //       )
    //     );
    //   },
    // },
  ];
  return (
    <div>
      {headerContent}

      <StyledTable
        dataSource={dataList?.kpirole}
        columns={columns}
        className="small_table mb-3 mt-2"
        rowKey="key"
        pagination={false}
      />
    </div>
  );
};

export default ViewKpi;
